import { useRef, useEffect, useState } from 'react';
import { useBlocker } from './UseBlocker';

const CustomPrompt = (messageObj, shouldPrompt, isConfirmed, header, subheader, onConfirm) => {
    const [confirmedNavigation, 
        setConfirmedNavigation
    ] = useState(false);

    const retryFn = useRef(() => { });

    useEffect(() => {
        if (confirmedNavigation) {
            retryFn.current()
        }
    }, [confirmedNavigation])

    const HandleBlockNavigation = async ({ retry, saved }) => {
        const shouldDisplayPrompt = typeof shouldPrompt === "boolean" ? shouldPrompt && !saved : shouldPrompt();
        if (shouldDisplayPrompt) {
            const test = await isConfirmed(header, subheader);
            if (test) {
                if (onConfirm) {
                    await onConfirm();
                }
                setConfirmedNavigation(true);
                retryFn.current = retry
            }
        } else {
            retry();
        }
    }

    const shouldBlock =
        typeof shouldPrompt === "boolean"
            ? shouldPrompt
            : shouldPrompt();

    return useBlocker(HandleBlockNavigation, shouldBlock && !confirmedNavigation);
}

export default CustomPrompt;
